import React, { useState, useEffect } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { addToCart, newAddToCart, newAddToCartProcessing } from "../../../../_actions/cart.actions";
import { cartConstants } from "../../../../_constants";
import { isCourseInCart, buildCourseDetailsURI } from "../../../../_helpers";
import { Loading } from "../../../Other/Loading";
import { cart } from "@/_reducers/cart.reducer";

const AddToCartButton = ({
  post,
  cartItems,
  currentItem,
  history,
  // currentState,
  geoLocation,
  error,
  bundle,
}) => {
  const dispatch = useDispatch();

  const { CartItemsList, CartItemsID, currentState } = useSelector((state) => state.cart);

  const { loggedIn } = useSelector((state) => state.authentication);
  const { t } = useTranslation();

  const getCoupon = (cartItems) => {
    return cartItems.find((item) => item.PromoApplied)?.PromoCodeApplied;
  };

  const handleCartClick = (
    event,
    loggedIn,
    history,
    course,
    cartItems,
    geoLocation
  ) => {
    event.preventDefault();
    if (loggedIn) {
      let req = {};
      if (bundle) {
        req = { "bundles": [course.ID] };
      } else {
        req = { "courses": [course.ID] };
      }
      console.log("course id", course.ID,cartItems);
      return dispatch(
        addToCart(req, getCoupon(cartItems), geoLocation, bundle, course.CourseName || course.name)
      );
    } else {
      // without login User
      if (CartItemsList.length > 0) {
        let newArray = CartItemsList;
        let check = newArray.some(obj => {
          if (obj.ID === course.ID) {
            return true;
          }
          return false;
        });
        if (check) {
          let updateVal = newArray.filter((obj) => obj.ID !== course.ID);
          return dispatch(
            newAddToCart(updateVal)
          );
        } else {
          // let addID = { ...course, ID: parseInt(course.id) }
          // console.log("🚀 ~ file: 63 ~ addID:", addID)
          newArray.push(course);
          dispatch(newAddToCartProcessing(course.ID));
          setTimeout(() => {
            return dispatch(
              newAddToCart(newArray)
            );
          }, 500);

          // return dispatch(
          //   newAddToCart(newArray)
          // );
        }
      } else {
        dispatch(newAddToCartProcessing(course.ID));
        setTimeout(() => {
          return dispatch(
            newAddToCart([course])
          );
        }, 500);
      }

    }
  };

  const SuccessResponse = ({ isAdded, error }) => {
    const [isActive, setActive] = useState(true);
    useEffect(() => {
      const timeoutID = setTimeout(() => {
        setActive(false);
        // dispatch({ type: cartConstants.ADD_TO_CART_RESET });
      }, 2000);
      return () => clearTimeout(timeoutID);
    }, []);
    return isActive ? (
      <a href="javascript(void);" className="disabled">
        <span className={`add-to-cart ${isAdded ? "success" : "failed"}`}>
          {isAdded ? "Item Added to Cart" : error}
        </span>
      </a>
    ) : isAdded ? (
      <GoToCart />
    ) : (
      <AddToCart />
    );
  };

  const renderCartButton = (
    loggedIn,
    cartItems,
    post,
    error,
    currentStatus
  ) => {
    console.log("currentStatus", currentStatus);
    switch (currentStatus) {
      case "processing":
        return (
          <a href="javascript(void);" className="disabled">
            <Loading />
          </a>
        );
      case "success":
        return <SuccessResponse isAdded={true} />;
      case "failed":
        return <SuccessResponse error={error} />;
      default:
        return isCourseInCart(
          loggedIn,
          cartItems,
          post,
          bundle ? true : false
        ) ? (
          <GoToCart />
        ) : (
          <>{!post?.isPurchased || post?.isPurchased === "false" ? <AddToCart /> : <PurchasedCourse />}</>
        );
    }
  };

  const AddToCart = () => {
    return (
      <>
        <a
          href="javascript(void);"
          className="!text-white !bg-[#264b82] !px-3 py-0 !rounded-md !text-sm !font-semibold"
          onClick={(event) =>
            handleCartClick(
              event,
              loggedIn,
              history,
              post,
              cartItems,
              geoLocation
            )
          }
        >
          <span className="add-to-cart">{t("addToCart")}</span>
        </a>
      </>
    );
  };

  const GoToCart = () => {

    return <Link className="!text-white !bg-[#264b82] !px-3 !py-2 !rounded-md !text-sm !font-semibold" to="/cart">{t("goToCart")}</Link>;
  };

  const PurchasedCourse = () => {
    return (
      <Link
        to={{
          pathname: buildCourseDetailsURI(
            post.Category || post.category,
            post.CourseName,
            post.ID
          ),
        }}
      >
        <span>PURCHASED</span>
      </Link>
    );
  };
  const PurchasedCourseFunc = () => {
    console.log("CartItemsList", CartItemsList, post.ID,CartItemsID,currentItem);
    return (
      !loggedIn && !CartItemsID ?
        currentItem !== post.ID ?
          <a href="javascript(void);" className="disabled">
            <Loading />
          </a>
          : CartItemsList.length > 0 &&
            CartItemsList.find((obj) =>
              obj.ID === post.ID) ?
            <GoToCart />
            :
            <AddToCart /> :
        currentItem === post.ID
          ? renderCartButton(loggedIn, cartItems, post, error, currentState)
          : renderCartButton(loggedIn, cartItems, post, error)
    );
  };

  // const PurchasedCourseFunc = React.useCallback(() => {
  //   return (
  //     CartItemsList.length > 0 && CartItemsList.find((obj) => obj.ID === post.ID) ?
  //       <GoToCart />
  //       :
  //       <AddToCart />
  //   )
  // }, [CartItemsList.length]);


  return (
    // <>
    //   {/* {currentItem === post.ID
    //     ? renderCartButton(loggedIn, cartItems, post, error, currentState)
    //     : renderCartButton(loggedIn, cartItems, post, error)} */}
    <PurchasedCourseFunc />
  );
};

function mapStateToProps(state) {
  const { loggedIn, geoLocation } = state.authentication;
  const { cartItems, currentItem, error, CartItemsList } = state.cart;
  return {
    geoLocation,
    loggedIn,
    cartItems,
    currentItem,
    error,
    CartItemsList
  };
}

const CartButton = connect(mapStateToProps)(AddToCartButton);
export default CartButton;
